module.exports = __webpack_public_path__ + "static/media/green.98f5d461.gif";